/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_TaxonomyInputs */

const en_page_title_taxonomy = /** @type {(inputs: Page_Title_TaxonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxonomy`)
};

const nl_page_title_taxonomy = /** @type {(inputs: Page_Title_TaxonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxonomie`)
};

/**
* | output |
* | --- |
* | "Taxonomy" |
*
* @param {Page_Title_TaxonomyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_taxonomy = /** @type {((inputs?: Page_Title_TaxonomyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_TaxonomyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_taxonomy(inputs)
	return en_page_title_taxonomy(inputs)
});